import { api } from '@/shared/api';
import { API_ENDPOINTS } from '@/constants/api';
import { normalizePaginatedResponse } from '@/shared/api/pagination';
import type { PaginatedApiResponse } from '@/shared/api/pagination';
import type { PaginatedResponse } from '@/shared/types/entity';
import type { BlockedCheckoutLog } from '../types';

export const blockedCheckoutsApi = {
  getList: async (params?: {
    page?: number;
    perPage?: number;
    search?: string;
    dateFrom?: string;
    dateTo?: string;
  }): Promise<PaginatedResponse<BlockedCheckoutLog>> => {
    const response = await api.get<PaginatedApiResponse<BlockedCheckoutLog>>(
      API_ENDPOINTS.CHECKOUT_VALIDATION_ERRORS.LIST,
      { params },
    );
    return normalizePaginatedResponse(response.data);
  },
};
